import React from "react";
import {
  parseAmount,
  CURRENCY_EURO,
  parsePrepaidCardCode
} from "../../utils/utils";
import I18n from "i18n-js";




const PrepaidCardsGrid = ({
  prepaidCards,
  prepaidCardsAnimationDivider
}) => {

  

  return (
    <div className="row w-100 p-0 mx-0 mt-0 mb-5">
      {prepaidCards.map((prepaidCard, i) =>
        <div key={prepaidCard.id} id={prepaidCard.id}
          className="col-12 col-sm-6 col-lg-4 col-xxxl-3 py-3 px-1 px-sm-2"
        >
          <div className="br-20px border-aiG-light-gray-imp bg-aig-gradient px-0 py-4 prepaid_card_container"
          //  style={{ animation: `scale-up 0.5s ease-out ${0.100 * (i % prepaidCardsAnimationDivider)}s forwards` }}>
          >
            <div className="w-100 bg-white h-34px-imp"></div>

            <div className="row p-0">
              <div className="col-12 d-block justify-content-end text-right align-content-center pr-4 my-3">
                <h3 className="color-white m-0 p-0">
                  <b>{parseAmount(prepaidCard.amount, 0)}{CURRENCY_EURO}</b>
                </h3>

                <h5 className="color-white mb-0 p-0">
                  <b>{I18n.t('js.indexPrepaidCards.middlemanFee')}: {parseAmount(prepaidCard.middleman_fee, 2)}{CURRENCY_EURO}</b>
                </h5>
              </div>

              <div className="col-12 d-flex justify-content-start text-left px-0">
                <div className="bg-white br-20px py-2 px-1 px-sm-2 px-xl-3 ml-4">
                  <b>{parsePrepaidCardCode(prepaidCard.code)}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrepaidCardsGrid;